/* eslint-disable */
export default {
  close: 'Fechar',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
